var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "divBox",
    },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card",
          attrs: { shadow: "never", bordered: false },
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              staticClass: "form-boder-padding",
              attrs: {
                rules: _vm.rules,
                model: _vm.formData,
                "label-width": "130px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "客服：", prop: "popupId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "from-ipt-width",
                      attrs: {
                        placeholder: "请选择客服",
                        filterable: "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.formData.popupId,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "popupId", $$v)
                        },
                        expression: "formData.popupId",
                      },
                    },
                    _vm._l(_vm.qrcodeList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.pageName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "客服按钮文案：", prop: "popupDesc" } },
                [
                  _c("el-input", {
                    staticClass: "from-ipt-width",
                    attrs: {
                      maxlength: "4",
                      "show-word-limit": "",
                      placeholder: "请输入客服按钮文案",
                    },
                    model: {
                      value: _vm.formData.popupDesc,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.formData,
                          "popupDesc",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "formData.popupDesc",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "提现说明：", prop: "withdrawDesc" } },
                [
                  _c(
                    "div",
                    { staticStyle: { width: "500px" } },
                    [
                      _c("Tinymce", {
                        model: {
                          value: _vm.formData.withdrawDesc,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "withdrawDesc", $$v)
                          },
                          expression: "formData.withdrawDesc",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["platform:commission:config:update"],
                          expression: "['platform:commission:config:update']",
                        },
                      ],
                      attrs: { type: "primary", loading: _vm.loading },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmit("formData")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }